import { useEffect, useState } from "react"
import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'

import { FooterForm, Banner, } from '../components'
import { tracking } from '../utils/tracking'
import { imgs } from "../assets/imgs"
import { useResizeImg } from '../hooks/useResizeImg'

export const Agenda = () => {
   document.title = "New York Venture Summit | Agenda"

   const imageSource = useResizeImg(imgs.agenda.agendaBannerDesktop, imgs.agenda.agendaBannerMobile)
   const [isLoading, setIsLoading] = useState(true)
   const { day } = useParams()
   const navigate = useNavigate()
   const { search } = useLocation()

   useEffect(() => {
      if (!day) navigate('0' + search)
   }, [day]) 
   
   return (
      <div className='agenda'>
         <Banner imageSource={imageSource} isLoading={isLoading} setIsLoading={setIsLoading} >
            <section>
               <h1 >Explore Engaging Content</h1>
            </section>
            <section>
               <Link className='btn b2' to='/registration' onClick={() => tracking(290)} >get your ticket</Link>
            </section>
         </Banner>
         <Outlet />
         {/* <h1 style={{ color: 'black', textAlign: 'center', fontSize: '1.5em', margin: '1.5em' }}>Agenda coming soon.</h1> */}
         <FooterForm />
      </div>
   );
};
